export const arce = (state) => state.arce
export const arceClientId = (state) => state.arce ? state.arce.groupId : 0
export const files = (state) => {
	return state.caseFile.find(item => item.client_id == state.arce.groupId )
}